export default __webpack_public_path__ + "static/media/Web.0bef9336.png";